import React, { FC } from 'react';
import { BoxProps } from '../../types';
import * as S from './styles';

export const Page: FC<BoxProps> = ({ children, ...props }) => (
	<S.Page {...props}>{children}</S.Page>
);

Page.defaultProps = {
	height: '100vh',
	width: '100vw',
};
